import BaseDrawTool from "./BaseDrawTool";
import {AnnotationsConstants} from "../../../utils/const";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import React from "react";
import {getUperpixel} from "../../../utils/utils";

class Circle extends BaseDrawTool {

	id = "Circle";
	name = "Circle";
	type = "Circle";
	shape = AnnotationsConstants.CIRCLE;
	icon = <CircleOutlinedIcon/>
	maxPoints = 2;
	className = "Circle-forTour"
	shortcutKey = "3";

	getArea = (geometry) => Math.PI * Math.pow(geometry.getRadius(), 2);
	getPerimeter = (geometry) => 2 * Math.PI * geometry.getRadius();
	getCoordinates = (geometry) => [geometry.getCenter(), geometry.getRadius()];
	getGeometricParams = (geometry) => ({
		area: geometry.getRadius() * getUperpixel() * geometry.getRadius() * getUperpixel() * Math.PI,
		perimeter: 2 * geometry.getRadius() * getUperpixel() * Math.PI,
		coordinates: [geometry.getCenter(), geometry.getRadius()],
	});
}

export default Circle;
